export const SET_API_PUBLIC_TOKEN = 'SET_API_PUBLIC_TOKEN'
export const SET_INITIAL_MODAL_SHOWN = 'SET_INITIAL_MODAL_SHOWN'
